export default {
  SELECT_PAGE: 'SELECT_PAGE',
  INITIALIZE_PAGINATION: 'INITIALIZE_PAGINATION'
}
